var THREE = require('three');
// require("imports?THREE=three!../STLLoader.js");
// require("imports?THREE=three!../OrbitControls.js");
var TWEEN = require("@tweenjs/tween.js");

// ------------------------------------------------
// SETUP
// ------------------------------------------------

var scene, loader, mesh, parts, manager, renderer, controls, camera, initCamPos, initCamRot;
parts= {
    top: true,
    bottom: true,
    modelActive: 0
};

function initScene(id) {
    scene = new THREE.Scene();
    loader = new THREE.STLLoader();


// Create a renderer with Antialiasing
    renderer = new THREE.WebGLRenderer({ antialias: true });
    manager = new THREE.LoadingManager();

    manager.onStart = function( item, loaded, total ) {
        var loader = document.createElement('div');
        var progressBar = document.createElement('progress');
        var textLoader = document.createElement('span');
        textLoader.textContent = "Cargando modelos";
        textLoader.className = "loaderText";
        progressBar.className="progress is-small is-primary";
        progressBar.value="0";
        progressBar.max="100";
        progressBar.style.height = "5px";
        loader.appendChild(progressBar);
        loader.appendChild(textLoader);


        loader.id = "loading";
        loader.className = "is-overlay";
        loader.style.background = "rgba(0,0,0,0.7)";
        loader.style.zIndex= 1200;
        loader.style.position = "absolute";
        loader.style.top = 0;
        loader.style.width = "100%";
        loader.style.height = "100%";
        document.body.appendChild(loader);

    };

    manager.onLoad = function() {
        document.body.removeChild(document.getElementById("loading"));
        renderer.setSize(document.getElementsByClassName("mainview")[0].offsetWidth, 600);

        document.getElementById(id).appendChild(renderer.domElement);
        //animate();
    };

    manager.onProgress = function( item, loaded, total ) {
        document.getElementsByTagName("progress")[0].value = (loaded/total)*100;
        // $("#loaderModal .progress-bar").width((loaded/total)*100+"%");
    };

    manager.onError = function( url ) {

    };

    loader.manager = manager;

// Create a basic perspective camera
    camera = new THREE.PerspectiveCamera(1, window.innerWidth / 600, 0.1, 1000);
    camera.position.z = 270;

    initCamPos = camera.position.clone();
    initCamRot = camera.rotation.clone();



// Configure renderer clear color
    renderer.setClearColor("#EDEDED");

// Configure renderer size
    controls = new THREE.OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true;
    controls.dampingFactor = 0.25;
    controls.enableZoom = true;

// ------------------------------------------------
// RENDER
// ------------------------------------------------
    var spotLight = new THREE.SpotLight(0xffffff);
    spotLight.position.set(-30, 10, 100);
    spotLight.castShadow = true;
    spotLight.intensity = 0.75;
    camera.add(spotLight);
    spotLight.target = camera;

    scene.add(camera);


    var light = new THREE.AmbientLight(0xFFFFFF); // soft white light
    light.intensity = 0.25;
    scene.add(light);
}

function animate() {
    requestAnimationFrame(animate);
    controls.update();
    render();
}
function render() {
    TWEEN.update();
    renderer.render(scene, camera);
}
function loadModel(model, id, index) {
    loader.load(model, function(geometry) {
        var material = new THREE.MeshPhongMaterial({ color: 0xEDEDED, specular: 0x111111, shininess: 200 });
        mesh = new THREE.Mesh(geometry, material);

        mesh.name = "object_" + id;
        if (index > 0) {
            mesh.visible = false;
        }

        mesh.position.set(0, 0, 0.2);
        mesh.rotation.set(0, 0, 0);
        mesh.scale.set(0.1, 0.1, 0.1);

        mesh.castShadow = true;
        mesh.receiveShadow = true;
        scene.add(mesh);
    });
}

function resetZoom() {
    var q1 = new THREE.Quaternion(initCamRot).normalize();

    new TWEEN.Tween(camera.position)
        .to(initCamPos, 1000)
        .easing(TWEEN.Easing.Cubic.Out)
        .start()
        .onComplete(function () {
            //Action on complete animation
        });
}

function changeView(axis) {
    // this.resetZoom();
    new TWEEN.Tween(camera.position)
        .to(axis, 1000)
        .easing(TWEEN.Easing.Cubic.Out)
        .start()
        .onComplete(function () {
            //Action on complete animation
        });
}

function getCamPos() {
    console.log(camera.position);
}

function showModel(index, models) {
    models.forEach(function (item, i) {
        var objectInf = scene.getObjectByName("object_" + i + "_0");
        var objectSup = scene.getObjectByName("object_" + i + "_1");

        objectInf.visible = false;
        objectSup.visible = false;
    });
    var objectInf = scene.getObjectByName("object_" + index + "_0");
    var objectSup = scene.getObjectByName("object_" + index + "_1");

    objectInf.visible = parts.bottom;
    objectSup.visible = parts.top;
}

function showPart() {
    console.log(parts.modelActive)
    var objectInf = scene.getObjectByName("object_" + parts.modelActive + "_0");
    var objectSup = scene.getObjectByName("object_" + parts.modelActive + "_1");

    objectInf.visible = parts.bottom;
    objectSup.visible = parts.top;
}
function removeScene() {
    scene.children.forEach(function(child){
        if(child.type === "Mesh"){
            child.geometry.dispose();
            child.material.dispose();
        }

    });

    var to_remove = [];
    scene.traverse ( function( child ) {
        if ( child instanceof THREE.Mesh && !child.userData.keepMe === true ) {
            to_remove.push( child );
        }
    } );
    for ( var i = 0; i < to_remove.length; i++ ) {
        scene.remove( to_remove[i] );
    }
    renderer.renderLists.dispose();
    renderer.dispose();
}

export default {
    init: initScene,
    loadModel: loadModel,
    resetZoom: resetZoom,
    changeView: changeView,
    getCamPos: getCamPos,
    showModel: showModel,
    showPart: showPart,
    animate: animate,
    removeScene: removeScene,
    parts: parts
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/Scene.js